import { render, staticRenderFns } from "./vehicleTeamEdit.vue?vue&type=template&id=5f0321eb&scoped=true"
import script from "./vehicleTeamEdit.vue?vue&type=script&lang=js"
export * from "./vehicleTeamEdit.vue?vue&type=script&lang=js"
import style0 from "./vehicleTeamEdit.vue?vue&type=style&index=0&id=5f0321eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0321eb",
  null
  
)

export default component.exports